import { connect } from 'react-redux';
import differenceBy from 'lodash/differenceBy';
import { toggleFeaturesModal, PAP_STEPS } from 'project/ducks/features';
import { fetchProject, getProject } from 'project/ducks/project';
import { updateProjectRequest } from 'pap/ducks/project';
import { updateFeaturesRequest } from 'pap/ducks/pricing';
import { PACKAGE_ITEMS } from 'pap/ducks/workflow';
import { PAP_VALIDATION_FUNCTIONS_MAP } from 'pap/components/common/input_fields';
import { getDetailedCost } from 'pap/utils';
import FeaturesModal from 'project/components/features_modal';

/* Re-use PAP feature options step validation, just translating props appropriately. */
const validate = (value, allValues, props) => {
  if (!props) return undefined;

  return PAP_VALIDATION_FUNCTIONS_MAP.featureProjectFields(
    value, allValues, { projectData: props.project }
  );
};

const mapStateToProps = (state) => {
  const project = getProject(state);
  const form = state.form.FeaturesModal;
  const formValues = form ? (form.values || {}) : {};
  const oldCost = getDetailedCost(project.features, project.award_rules, {});
  const newCost = getDetailedCost(project.features, project.award_rules, formValues);
  const upgradeItems = differenceBy(newCost.items, oldCost.items, 'name');
  const upgradeCost = newCost.total - oldCost.total;

  return {
    papSteps: PAP_STEPS,
    packageItems: PACKAGE_ITEMS,
    project,
    upgradeItems,
    upgradeCost,
    validate
  };
};

export default connect(mapStateToProps, {
  onClose: toggleFeaturesModal,
  updateFeaturesRequest,
  updateProjectRequest,
  fetchProject
})(FeaturesModal);



// WEBPACK FOOTER //
// ./project/containers/features_modal.js